import { render } from "./top_menu_vertical_line.vue?vue&type=template&id=9072d8cc&scoped=true"
const script = {}

import "./top_menu_vertical_line.vue?vue&type=style&index=0&id=9072d8cc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9072d8cc"]])

export default __exports__